import { doesQualifyToBeHidden } from './ItemAvailabilityStatus'
import { getCountableMSServicesCount } from './MSServices'
import type { ICompany, ICompanyMasterService } from '~/types/company/models'

const mn = '[cynqueModules/dataObjects/CompanyMasterService.ts]'

export function CompanyMasterService(cms: ICompanyMasterService) {
  const fn = `${mn} CompanyMasterService |`
  console.debug(`${fn} Called`)
  _setLabelWithHrid(cms)
  _initializeEmptyCompanyMSServicesArray(cms)
  _calculateUnstoredOMSValues(fn, cms)
  return cms
}

// Helper functions

function _setLabelWithHrid(cms: ICompanyMasterService) {
  cms.labelWithHrid = `${cms.descr} (${cms.hrid})`
}

function _initializeEmptyCompanyMSServicesArray(cms: ICompanyMasterService) {
  if (!cms.companyMSServices) {
    cms.companyMSServices = []
  }
  if (!cms.companyMSTeamMembers) {
    cms.companyMSTeamMembers = []
  }
}

function _calculateUnstoredOMSValues(fn: string, cms: ICompanyMasterService) {
  cms.numLocations = new Set(
    cms.companyMSServices
      .filter((cmss) => cmss.doInclude && !doesQualifyToBeHidden(cmss))
      .map((cmss) => cmss.location.id)
  ).size
  console.debug(`${fn} numLocations set to ${cms.numLocations} for ${cms.id}`)
  cms.numServices = getCountableMSServicesCount(cms.companyMSServices)
  console.debug(`${fn} numServices set to ${cms.numServices} for ${cms.id}`)
}

// Propagators

export function propagateCompanyMSDataToCompany({
  callingFn,
  company,
  masterServices,
  setUpCompany,
}: {
  callingFn: string
  company: ICompany
  masterServices: ICompanyMasterService[]
  setUpCompany: Function
}) {
  const fn = `${callingFn} ---> ${mn} propagateCompanyMSDataToCompany |`
  console.debug(`${fn} masterServices:`, masterServices)
  company.numCompanyMasterServices = masterServices?.length ?? 0
  console.debug(
    `${fn} company.numMasterServices set to:`,
    company.numCompanyMasterServices
  )
  setUpCompany(company)
}
